<template>
  <span
    :class="_class"
    v-on="$listeners"
    @click="onClick"
  >
    <span
      :class="_linkClass"
    >
      <slot />
    </span>
    <span
      :class="_separatorClass"
    >
      <render-cell
        :render="renderSeparator"
      />
    </span>
  </span>
</template>

<script>
import RenderCell from '../render-cell';
const name = 'ten-breadcrumb__item';

export default {
  name,
  inject: {
    breadcrumb: {
      from: 'breadcrumb',
      default: null,
    },
  },
  components: {
    RenderCell,
  },
  props: {
    /**
     * 路由跳转对象
     */
    route: [Object, String],
    /**
     * 在进行路由跳转时，启用 replace 将不会向 history 添加新记录
     */
    replace: Boolean,
    /**
     * 自定义分隔符
     */
    separator: String,
  },
  computed: {
    _showSeparator() {
      return this.separator !== undefined && this.separator !== '';
    },
    _class() {
      return [name];
    },
    _linkClass() {
      return [`${name}-link`, `${name}__text`];
    },
    _separatorClass() {
      return ['ten-breadcrumb__separator'];
    },
  },
  methods: {
    onClick() {
      if (this.route && this.$router) {
        try {
          this.replace
            ? this.$router.replace(this.route, () => {}, error => console.error(error))
            : this.$router.push(this.route, () => {}, error => console.error(error));
        } catch (e) {
          console.error(e);
        }
      }
    },
    renderSeparator() {
      let separator;
      if (this.$scopedSlots.separator) {
        separator = this.$scopedSlots.separator();
      } else if (this.separator) {
        separator = this.separator; // eslint-disable-line
      } else {
        separator = this.breadcrumb.renderSeparator();
      }
      return (
        <span class="ten-breadcrumb__separator">{separator}</span>
      );
    },
  },
};
</script>
